import { render, staticRenderFns } from "./StockMatch.vue?vue&type=template&id=4f1468ff&scoped=true&"
import script from "./StockMatch.vue?vue&type=script&lang=js&"
export * from "./StockMatch.vue?vue&type=script&lang=js&"
import style0 from "./StockMatch.vue?vue&type=style&index=0&id=4f1468ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1468ff",
  null
  
)

export default component.exports